import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useSWR from "swr";
import { useAuth } from "../../../../Context/AuthContext";
import QueryString from "qs";
import { orderUrls } from "../../../../Api/Auth/ApiUrls";
import { fileFetcher } from "../../../../Api/swrConfig";
import Button from "../../../../Components/Common/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import { studentPracticeHubTabsData } from "../../../../data/SidebarData";
import { Loader } from "../../../../Components/Common/Loader";
import { publicUrls, studentUrls } from "../../../../Api/Auth/AppUrls";
import Accordion from "../../../Home/Components/Accordion";
import Modal from "../../../../Components/Common/Modal";
import PDFViewer from "../../../../Components/Common/SecurePDFViewer";
import { checkStudentRouteVisibility } from "../../../../utils/findStudentRouteBySlug";
import NotFound from "../../../Notfound";

const StudentPracticeHubMechanical = () => {
  const { userData, categoryData } = useAuth();
  const location = useLocation();
  const [selected, setSelected] = useState(null);
  const parts = location.pathname.split("/").filter(Boolean);
  const dynamicPath = `/${parts[0]}/${parts[1]}-${parts[2]}`;
  const dynamicSlug = dynamicPath.split("/")[dynamicPath.split("/").length - 1];
  const isVisibleCivil = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentPracticeHub
  );
  const isVisibleMechanical = checkStudentRouteVisibility(
    categoryData,
    studentUrls.studentPracticeHubMechanical
  );
  const visibleTabs = studentPracticeHubTabsData.filter((tab) => {
    if (!tab?.path) return true;
    if (tab.path === studentUrls.studentPracticeHub && !isVisibleCivil)
      return false;
    if (tab.path === studentUrls.studentPracticeHubMechanical && !isVisibleMechanical)
      return false;
    return true;
  });

  const apiQueryParams = {
    userId: userData?._id,
    itemType: "subscription",
    slug: dynamicSlug,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data } = useSWR(orderUrls.purchases(apiQueryString));
  const { data: fileUrl, isLoading: fileLoading } = useSWR(
    selected || null,
    (url) => fileFetcher(url)
  );

  const dataRender = data?.data?.topics?.map((item, index) => {
    return {
      title: item.title,
      content: (
        <div className="flex flex-col gap-3">
          <span className="font-normal text-xs">{item.description}</span>
          <div className="container mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 p-6">
            {item?.subtopic?.length ? (
              item?.subtopic?.map((sub) => (
                <div
                  key={sub._id}
                  className="bg-white shadow-lg hover:shadow-xl rounded-lg p-4 transition-all duration-300"
                >
                  <h2 className="text-sm font-semibold text-center">
                    {sub.title}
                  </h2>
                  <div className="flex flex-col items-center gap-2 mt-3">
                    {sub?.link?.length ? (
                      sub.link.map((link, i) => (
                        <Button
                          size="small"
                          className="flex gap-2 items-center mt-2"
                          onClick={() => setSelected(link)}
                        >
                          <FontAwesomeIcon icon={faEye} />
                          View
                        </Button>
                      ))
                    ) : (
                      <span className="text-gray-500">No available links.</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <span className="mt-2 flex flex-col justify-center gap-2 text-center items-center">
                No available content.
              </span>
            )}
          </div>
        </div>
      ),
    };
  });

  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs tabs={visibleTabs} />
      {!isVisibleMechanical ? (
        <NotFound />
      ) : (
        <>
          {isLoading ? (
            <Loader />
          ) : // eslint-disable-next-line
          data?.data == {} ? (
            <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase Practice Hub to get started.
              <Link to={publicUrls.practiceHubMechanical}>
                <Button>Practice Hub</Button>
              </Link>
            </span>
          ) : data?.data?.purchased ? (
            (() => {
              // const purchaseInfo = data?.status;
              const purchasedAt = data?.data?.purchasedAt
                ? new Date(data?.data?.purchasedAt)
                : null;
              const duration = data?.data?.subscriptionDuration
                ? parseInt(data?.data?.subscriptionDuration, 10)
                : 0;

              if (!purchasedAt || isNaN(duration) || duration <= 0) {
                return (
                  <div className="text-red-600 font-semibold">
                    ⚠️ Subscription data is missing or invalid.
                  </div>
                );
              }

              const expirationDate = new Date(purchasedAt);
              expirationDate.setDate(expirationDate.getDate() + duration);

              const today = new Date();
              const remainingDays = Math.max(
                0,
                Math.ceil((expirationDate - today) / (1000 * 60 * 60 * 24))
              );

              return (
                <>
                  <p className="font-semibold mt-4 mb-4">
                    <span className="text-gray-700">
                      {remainingDays > 0
                        ? ` Your subscription expires in ${remainingDays} day${
                            remainingDays > 1 ? "s" : ""
                          }.`
                        : "Your subscription has expired."}
                    </span>
                  </p>
                  {data?.data?.topics?.length ? (
                    <Accordion accordionData={dataRender} fullWidth openFirst />
                  ) : (
                    ""
                  )}
                </>
              );
            })()
          ) : (
            <span className=" mt-2  flex flex-col justify-center gap-2 text-center items-center">
              No available content. Purchase Practice Hub to get started.
              <Link to={publicUrls.practiceHubMechanical}>
                <Button>Practice Hub</Button>
              </Link>
            </span>
          )}
          <Modal
            isOpen={selected !== null}
            title={"View Practice Hub Item"}
            onCancel={() => setSelected(null)}
            footer={false}
            fullHeight
          >
            <div
              style={{
                width: "100%",
                height: "750px", // Set fixed height here instead of in PDFViewer
                position: "relative",
                border: "1px solid rgba(0, 0, 0, 0.3)",
              }}
              className="pdf-viewer-wrapper"
            >
              {fileLoading ? <Loader /> : <PDFViewer pdfUrl={fileUrl} />}
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default StudentPracticeHubMechanical;
